import type { VoidFunctionComponent } from 'react';
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';
import Icon, { icons } from '../Icon';
import { FormLabelVariant, LabeledTextInput } from '../Forms';
import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';
import type { TextInputProps } from '../Forms/TextInput';

/**
 * A disabled text input that can be copied to the clipboard.
 */
const InlineCopiableText: VoidFunctionComponent<TextInputProps> = ({
  label,
  value,
  ...props
}) => {
  const [isCopied, setIsCopied] = useCopyToClipboard();
  //  Inputs can be strings or numbers, this helps us ensure we're always working with a string.
  const valueAsString = value?.toString() ?? '';
  return (
    <ReactCopyToClipboard text={valueAsString} onCopy={() => setIsCopied(true)}>
      {/* This is required since it enforces that all children copy the text when clicked */}
      <div className="block">
        <LabeledTextInput
          // eslint-disable-next-line react/jsx-props-no-spreading -- There's a lot of props, so we want to spread them.
          {...props}
          label={label}
          value={valueAsString}
          suffix={<Icon icon={isCopied ? icons.check : icons.cloneO} testId="copy-to-clipboard-icon" />}
          labelVariant={FormLabelVariant.Filter}
          isReadOnly
        />
      </div>
    </ReactCopyToClipboard>
  );
};

export default InlineCopiableText;
